import React from "react";
import { useTranslation } from "react-i18next";

interface TourDetailsProps {
  tourTitle: string;
  img: string;
  guests: { guestNumber: number; type: string; price: number }[];
}

const TourDetails: React.FC<TourDetailsProps> = ({
  tourTitle,
  img,
  guests,
}) => {
  const { t } = useTranslation();
  return (
    <div className="} rounded-[1.25rem] border border-[#DCDCDC] p-[1.25rem] pt-[1.3125rem]">
      <div className="items-top flex space-x-4">
        <img
          src={img}
          alt="Niagara Tour"
          className="h-[5.8125rem] w-[7.25rem] rounded-[0.5rem] object-cover"
        />
        <div className="flex-col gap-[0.9375rem]">
          <div className="flex w-[22.5625rem] justify-start">
            <p className="mb-[0.9375rem] text-base font-semibold">
              {tourTitle}
            </p>
          </div>
          <div className="flex w-[22.5625rem] justify-start">
            <p className="flex text-[0.875rem] font-semibold text-[#5E6D77]">
              {t("Guest:")}
              <span className="text-[0.875rem] font-normal text-[#5E6D77]">
                {" "}
                {guests.map((g) => `${g.guestNumber} ${g.type}`).join(", ")}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourDetails;
